/**
 * base64url sobre UTF-8 — só letras, números, hífen e sublinhado, sem o `=` do fim.
 *
 * É o formato dos códigos que o app põe na mão das pessoas (percurso, resultados): cabe
 * num link e numa mensagem sem ser quebrado nem escapado.
 */

export function paraBase64url(s: string): string {
  const bytes = new TextEncoder().encode(s);
  let bin = '';
  for (const b of bytes) bin += String.fromCharCode(b);
  return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function deBase64url(s: string): string {
  const b = s.replace(/-/g, '+').replace(/_/g, '/');
  const bin = atob(b + '='.repeat((4 - (b.length % 4)) % 4));
  return new TextDecoder().decode(Uint8Array.from(bin, (ch) => ch.charCodeAt(0)));
}
